import type { UseFormReturn } from "react-hook-form";
import type { z } from "zod";

import { zodResolver } from "@hookform/resolvers/zod";
import { createPasswordBodyZod } from "@nlc/shared-types";
import { useForm } from "react-hook-form";

export type CreatePasswordFormData = z.infer<typeof createPasswordBodyZod>;

export function useCreatePasswordForm(): UseFormReturn<CreatePasswordFormData> {
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get("token") ?? undefined;

  return useForm<CreatePasswordFormData>({
    defaultValues: {
      confirmPassword: "",
      password: "",
      token,
    },
    resolver: zodResolver(createPasswordBodyZod),
  });
}
